import { render, staticRenderFns } from "./SameLevelNavigation.vue?vue&type=template&id=5807ff80"
import script from "./SameLevelNavigation.vue?vue&type=script&lang=js"
export * from "./SameLevelNavigation.vue?vue&type=script&lang=js"
import style0 from "./SameLevelNavigation.vue?vue&type=style&index=0&id=5807ff80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports